/* 
    This method remove "\" from html string
    Accept params: encoded html
    Return: decode html
*/
export const decodeHTML = encodedHTML => encodedHTML.replace(/\\/g, '');
